import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.063 29.002c12.076 0 18.68-10.005 18.68-18.68 0-.285 0-.567-.019-.85C30.01 8.545 31.12 7.393 32 6.076c-1.198.53-2.47.879-3.77 1.032 1.37-.82 2.395-2.11 2.886-3.63-1.29.764-2.7 1.303-4.17 1.593-2.035-2.164-5.268-2.694-7.887-1.292-2.62 1.401-3.973 4.386-3.3 7.28-5.28-.265-10.198-2.758-13.532-6.86-1.742 3-.852 6.838 2.033 8.764-1.045-.03-2.067-.313-2.98-.822v.084c0 3.125 2.204 5.817 5.267 6.435-.966.264-1.98.303-2.964.113.86 2.675 3.325 4.507 6.133 4.56-2.324 1.827-5.196 2.818-8.153 2.815-.522 0-1.044-.032-1.563-.094 3.002 1.927 6.496 2.949 10.063 2.944",
		fill: "#1DA1F2",
		fillRule: "nonzero"
	})
});
export default SvgKgCardTypeTwitter;
